import React from "react";
import { Box, IconButton, StarIcon } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const IconButtonSizes = () => {
  return (
    <Box p={3} sx={{ width: "80%", margin: "0 auto" }}>
      <PreviewAndEditor
        title={"Medium, Large and small Icon Buttons"}
        height={"150px"}
        language={"js"}
        value={
          "<IconButton>\n" +
          "      <StarIcon />\n" +
          "</IconButton>\n\n" +
          '<IconButton size={"large"}>\n' +
          "      <StarIcon />\n" +
          "</IconButton>\n\n" +
          '<IconButton size={"small"}>\n' +
          "      <StarIcon />\n" +
          "</IconButton>"
        }
      >
        <IconButton>
          <StarIcon />
        </IconButton>
        <IconButton size={"large"}>
          <StarIcon />
        </IconButton>
        <IconButton size={"small"}>
          <StarIcon />
        </IconButton>
      </PreviewAndEditor>
    </Box>
  );
};

export default IconButtonSizes;
